import LegalShell from "@/components/LegalShell";

export default function Cookies() {
    return (
        <LegalShell title="Cookie Policy" testId="page-cookies">
            <p className="text-sm text-aq-muted">
                <strong>Last updated:</strong> 28 June 2026
            </p>

            <p>
                This Cookie Policy explains how TheCounselCo ("we", "us") uses cookies and similar
                technologies on the AcademiQ website. By using our site, you agree to our use of
                cookies as described below.
            </p>

            <h2>What are cookies?</h2>
            <p>
                Cookies are small text files placed on your device when you visit a website. They
                help the site work properly, remember your preferences, and understand how visitors
                use it.
            </p>

            <h2>Cookies we use</h2>
            <ul>
                <li>
                    <strong>Essential cookies</strong> — required to load the site, open the
                    secure Razorpay payment window and remember your progress through checkout.
                    These cannot be switched off.
                </li>
                <li>
                    <strong>Analytics cookies</strong> — used to understand, in aggregate, which
                    pages are visited and how long visitors stay, so we can improve the page. No
                    individual is identified from analytics.
                </li>
                <li>
                    <strong>Third-party cookies</strong> — Razorpay (our payment processor) sets
                    its own cookies during checkout to keep your transaction secure. Razorpay's
                    cookie use is governed by its own policy.
                </li>
            </ul>

            <h2>What we do NOT do</h2>
            <p>
                We do not use cookies to sell your personal information, build advertising profiles
                of your child, or share your data with third-party advertisers.
            </p>

            <h2>Your choices</h2>
            <p>
                You can clear or block cookies via your browser settings at any time. Note that
                disabling essential cookies may prevent the payment window from opening correctly.
            </p>

            <h2>Changes</h2>
            <p>
                We may update this policy from time to time. The latest version will always be
                posted here.
            </p>

            <h2>Contact</h2>
            <p>
                Questions about cookies or data?{" "}
                <a href="mailto:thecounselco@gmail.com">thecounselco@gmail.com</a>.
            </p>
        </LegalShell>
    );
}
